import React from 'react';
import { makeQrSvgDataUri } from '../utils/qrcode';
import { formatFCFA, formatDateTime, getAppBaseUrl, getParcelCode, getParcelTrackUrl } from '../utils/helpers';
import { PAIEMENTS } from '../data/constants';

export default function ModalEtiquette({ colis, onClose }) {
  if (!colis) return null;

  const colisCode = getParcelCode(colis);
  const trackUrl = getParcelTrackUrl(colis);
  let qrImg = null;
  try {
    qrImg = makeQrSvgDataUri(trackUrl, 260, { ecLevel: 'M', quiet: 4 });
  } catch {
    qrImg = null;
  }

  const meta = colis.meta || {};
  const amountDue = meta.amount_due ?? colis.prix ?? 0;
  const paymentRequired = meta.payment_required === true || meta.payment_required === 1 || meta.payment_required === '1';
  const modePaiement = PAIEMENTS[colis.paiement]?.label || colis.paiement || 'Espèces';

  const handlePrint = () => {
    window.print();
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(15, 23, 42, 0.75)',
      backdropFilter: 'blur(4px)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
      padding: 16,
    }}>
      <style>{`
        @media print {
          body * {
            visibility: hidden !important;
          }
          #printable-label, #printable-label * {
            visibility: visible !important;
          }
          #printable-label {
            position: absolute !important;
            left: 0 !important;
            top: 0 !important;
            width: 100% !important;
            max-width: 400px !important;
            box-shadow: none !important;
            border: 2px solid #000 !important;
            margin: 0 !important;
            padding: 16px !important;
          }
          .no-print {
            display: none !important;
          }
        }
      `}</style>

      <div style={{
        background: 'white',
        borderRadius: 20,
        width: '100%',
        maxWidth: 460,
        maxHeight: '90vh',
        overflowY: 'auto',
        boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
        display: 'flex',
        flexDirection: 'column',
      }}>
        {/* Header non imprimable */}
        <div className="no-print" style={{
          padding: '16px 20px',
          borderBottom: '1px solid #e2e8f0',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          background: '#f8fafc',
          borderTopLeftRadius: 20,
          borderTopRightRadius: 20,
        }}>
          <div style={{ fontWeight: 900, color: '#0f172a', fontSize: 16, display: 'flex', alignItems: 'center', gap: 8 }}>
            <span>🖨️</span> Étiquette Colis pour Imprimer
          </div>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              fontSize: 20,
              cursor: 'pointer',
              color: '#64748b',
              padding: 4,
            }}
          >
            ✕
          </button>
        </div>

        {/* CONTENU DE L'ÉTIQUETTE IMPRIMABLE */}
        <div style={{ padding: 20 }}>
          <div id="printable-label" style={{
            border: '2px solid #0f172a',
            borderRadius: 16,
            padding: 16,
            background: '#ffffff',
            color: '#0f172a',
            fontFamily: "'Inter', sans-serif",
          }}>
            {/* Header étiquette */}
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              borderBottom: '2px dashed #cbd5e1',
              paddingBottom: 12,
              marginBottom: 12,
            }}>
              <div>
                <div style={{ fontSize: 18, fontWeight: 900, letterSpacing: '-0.5px', color: '#4F46E5' }}>
                  📦 ZAKI EXPRESS
                </div>
                <div style={{ fontSize: 10, color: '#64748b', textTransform: 'uppercase', fontWeight: 800 }}>
                  Logistique & Livraison Dakar
                </div>
              </div>
              <div style={{ textAlign: 'right' }}>
                <span style={{
                  fontSize: 11,
                  fontWeight: 900,
                  background: '#f1f5f9',
                  padding: '4px 8px',
                  borderRadius: 6,
                  border: '1px solid #cbd5e1',
                  textTransform: 'uppercase',
                }}>
                  {colis.zone || 'Dakar'}
                </span>
              </div>
            </div>

            {/* Code QR + Code Colis */}
            <div style={{
              display: 'flex',
              gap: 16,
              alignItems: 'center',
              background: '#f8fafc',
              border: '1px solid #e2e8f0',
              borderRadius: 12,
              padding: 12,
              marginBottom: 14,
            }}>
              {qrImg ? (
                <img
                  src={qrImg}
                  alt="QR Code"
                  width={110}
                  height={110}
                  style={{ borderRadius: 8, border: '1px solid #cbd5e1', background: 'white' }}
                />
              ) : (
                <div style={{ width: 110, height: 110, background: '#eee', borderRadius: 8 }} />
              )}
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 10, textTransform: 'uppercase', color: '#64748b', fontWeight: 800 }}>
                  Code Colis / Tracking
                </div>
                <div style={{ fontSize: 16, fontWeight: 1000, color: '#4F46E5', letterSpacing: '0.5px', wordBreak: 'break-all' }}>
                  {colis.id}
                </div>
                <div style={{ fontSize: 10, color: '#475569', marginTop: 4, fontStyle: 'italic' }}>
                  📱 Scannez pour détails & actions livreur
                </div>
              </div>
            </div>

            {/* Destinataire */}
            <div style={{
              border: '1.5px solid #0f172a',
              borderRadius: 10,
              padding: 12,
              marginBottom: 10,
              background: '#ffffff',
            }}>
              <div style={{ fontSize: 10, textTransform: 'uppercase', fontWeight: 900, color: '#64748b', marginBottom: 2 }}>
                🎯 DESTINATAIRE
              </div>
              <div style={{ fontSize: 16, fontWeight: 900, color: '#0f172a' }}>
                {colis.destinataire || colis.nom || 'Client'}
              </div>
              <div style={{ fontSize: 18, fontWeight: 1000, color: '#0284c7', margin: '2px 0' }}>
                📞 {colis.tel || colis.telephone || '—'}
              </div>
              <div style={{ fontSize: 12, fontWeight: 700, color: '#334155', marginTop: 4 }}>
                📍 {colis.adresse || '—'} ({colis.zone || 'Dakar'})
              </div>
            </div>

            {/* Expéditeur & Montant à encasser */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 12 }}>
              <div style={{
                background: '#f8fafc',
                border: '1px solid #e2e8f0',
                borderRadius: 10,
                padding: 10,
              }}>
                <div style={{ fontSize: 9, textTransform: 'uppercase', fontWeight: 900, color: '#64748b' }}>
                  📤 EXPÉDITEUR
                </div>
                <div style={{ fontSize: 12, fontWeight: 800, color: '#0f172a' }}>
                  {colis.expediteur || 'Vendeur'}
                </div>
                {colis.expediteur_tel && (
                  <div style={{ fontSize: 11, fontWeight: 700, color: '#475569' }}>
                    {colis.expediteur_tel}
                  </div>
                )}
              </div>

              <div style={{
                background: paymentRequired && amountDue > 0 ? '#fef3c7' : '#dcfce7',
                border: `1.5px solid ${paymentRequired && amountDue > 0 ? '#f59e0b' : '#22c55e'}`,
                borderRadius: 10,
                padding: 10,
              }}>
                <div style={{ fontSize: 9, textTransform: 'uppercase', fontWeight: 900, color: paymentRequired && amountDue > 0 ? '#92400e' : '#166534' }}>
                  💵 À ENCAISSER (COD)
                </div>
                <div style={{ fontSize: 15, fontWeight: 1000, color: paymentRequired && amountDue > 0 ? '#b45309' : '#15803d' }}>
                  {paymentRequired && amountDue > 0 ? formatFCFA(amountDue) : 'DÉJÀ PAYÉ'}
                </div>
                <div style={{ fontSize: 10, fontWeight: 700, color: '#475569' }}>
                  Mode : {modePaiement}
                </div>
              </div>
            </div>

            {/* Footer étiquette */}
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              fontSize: 10,
              color: '#64748b',
              fontWeight: 700,
              borderTop: '1px solid #e2e8f0',
              paddingTop: 8,
            }}>
              <div>Date : {colis.date ? formatDateTime(colis.date) : new Date().toLocaleDateString('fr-FR')}</div>
              <div>ZakiExpress Delivery</div>
            </div>
          </div>
        </div>

        {/* Boutons d'action non imprimables */}
        <div className="no-print" style={{
          padding: '16px 20px',
          borderTop: '1px solid #e2e8f0',
          display: 'flex',
          gap: 12,
          justifyContent: 'flex-end',
          background: '#f8fafc',
          borderBottomLeftRadius: 20,
          borderBottomRightRadius: 20,
        }}>
          <button
            onClick={onClose}
            style={{
              padding: '10px 18px',
              borderRadius: 10,
              border: '1px solid #cbd5e1',
              background: 'white',
              color: '#475569',
              fontWeight: 800,
              fontSize: 14,
              cursor: 'pointer',
            }}
          >
            Fermer
          </button>
          <button
            onClick={handlePrint}
            style={{
              padding: '10px 22px',
              borderRadius: 10,
              border: 'none',
              background: '#4F46E5',
              color: 'white',
              fontWeight: 900,
              fontSize: 14,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              boxShadow: '0 4px 12px rgba(79, 70, 229, 0.3)',
            }}
          >
            <span>🖨️</span> Imprimer l'étiquette
          </button>
        </div>
      </div>
    </div>
  );
}
